<dialog class="modal-base" (click)="backdropClick($event)" (close)="close()" #dialog>
    <div class="modal-base__content">
        @if (!hideCloseButton()) {
            <stby-button-icon
                icon="close"
                shape="square"
                class="modal-base__close-button"
                tooltip="global.close"
                (clicked)="requestClose()"
            />
        }
        <ng-content />
    </div>
</dialog>
